import {inject, injectable} from 'inversify';
import {toJS} from 'mobx';

import type {BNUserProfileUpdateParams} from '../../../../../api/types/bnrks/methods';
import type {CoreUserProfileUpdateParams} from '../../../../../api/types/core/methods';
import type {UserMetadata} from '../../../../../api/user';
import type {UserMetadataModel} from '../UserMetadata.model';

import {mergeDeepObj} from '../../../../../utils/object/mergeDeepObj';
import {UserMetadataFactory} from '../UserMetadata.factory';

@injectable()
export class UserMetadataMapperJrpc {
  constructor(
    @inject(UserMetadataFactory)
    private readonly factory: UserMetadataFactory,
  ) {}

  mapDataToModel(apiData: UserMetadataMapperJrpc.ApiData): UserMetadataModel {
    return this.factory.create(this.mapDataToProps(apiData));
  }

  mapDataToProps(
    apiData: UserMetadataMapperJrpc.ApiData,
  ): UserMetadataModel.Props {
    return mergeDeepObj(UserMetadataFactory.EMPTY_PROPS, apiData);
  }

  mapModelToDto(model: UserMetadataModel): UserMetadataMapperJrpc.Dto {
    return toJS(model);
  }
}

export namespace UserMetadataMapperJrpc {
  export type ApiData = UserMetadata['metadata'];

  export type Dto =
    | BNUserProfileUpdateParams['metadata']
    | CoreUserProfileUpdateParams['metadata'];
}
